import { render, staticRenderFns } from "./ApriaPatrimonioDaHumanidadPuntos.vue?vue&type=template&id=6e1288fa&lang=pug"
import script from "./ApriaPatrimonioDaHumanidadPuntos.vue?vue&type=script&lang=js"
export * from "./ApriaPatrimonioDaHumanidadPuntos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports